import { createContext, useContext, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router';
import { LazyOutlet } from 'design-system/atoms/spinner-suspense';
import { useContextOrg } from '../ContextOrg';
import { pathOrgContractorsSettings } from '../../utils/path';

interface ContractorContextType {
  orgId: string;
  contractorId: string | null;
  setContractorId: (id: string | null) => void;
}

export const ContractorContext = createContext<ContractorContextType | null>(
  null
);

export function useContextContractor(): ContractorContextType {
  const context = useContext(ContractorContext);
  if (context === null) {
    throw new Error('Trying to use ContractorContext outside of its provider');
  }
  return context;
}

export default function ContextContractor() {
  const { orgId } = useContextOrg();
  const { contractorId } = useParams();
  const navigate = useNavigate();
  const contextValue = useMemo(
    () => ({
      orgId,
      contractorId: contractorId ?? null,
      setContractorId: (id: string | null) => {
        navigate(pathOrgContractorsSettings({ orgId, contractorId: id }), {
          preventScrollReset: true,
        });
      },
    }),
    [orgId, contractorId, navigate]
  );
  return (
    <ContractorContext.Provider value={contextValue}>
      <LazyOutlet />
    </ContractorContext.Provider>
  );
}
